import React from 'react';
import { GoogleOAuthProvider } from '@react-oauth/google';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useParams,
  useLocation
} from 'react-router-dom';

import LoginScreen from './LoginScreen';
import PaymentPage from './PaymentPage';
import LoginSignupComponent from './LoginSignupComponent';

const GOOGLE_CLIENT_ID =
  '518384026400-jqbace02mqdjgm0l51p6sq7fg8h2a740.apps.googleusercontent.com';

function PaymentRouteWrapper() {
  const { eventId, code } = useParams();
  const { state } = useLocation();
  const { eventTitle, eventImage } = state || {};

  return (
    <PaymentPage
      eventId={eventId || 316}
      code={code || null}
      eventTitle={eventTitle}
      eventImage={eventImage}
    />
  );
}

export default function App() {
  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <Router>
        <Routes>
          <Route path="/:eventId/:code?" element={<PaymentRouteWrapper />} />

          <Route path="/account/:eventId/:code?" element={<LoginScreen />} />
          <Route path="/login-signup/:eventId/:code?" element={<LoginSignupComponent />} />
        </Routes>
      </Router>
    </GoogleOAuthProvider>
  );
}
